import skillsEn from './skills.en';

export default skillsEn;
